<div>
  <ng-container *ngIf="isFileLoading">
    <mat-progress-bar mode="indeterminate" style="border-radius: 100px;"></mat-progress-bar>
  </ng-container>

  <span *ngIf="fileLoading">
    File Loading...
  </span>

  <div *ngIf="!fileLoading">
    <mat-list role="list" *ngIf="files.length > 0" class="uploadList">
      <mat-list-item role="listitem" *ngFor="let file of files">
        <mat-icon>cloud_download</mat-icon>
        {{file.file_name}}
        <!-- <mat-icon style="margin-left: auto;color: #039be5" matTooltip="Download">save_alt</mat-icon> -->
        <a [href]="file.url" target="_blank" matTooltip="Download" mat-icon-button color="accent"
          style="margin-left: auto;">
          <i class="material-icons" style="color:rgb(52, 55, 61);">get_app</i>
        </a>
      </mat-list-item>
    </mat-list>
  </div>

  <input hidden type="file" #docUpload (change)="uploadList($event)" />
  <div class="upload" (click)="docUpload.click()" style="max-height: 45px">
    <mat-icon style="float: left;margin-right: 5px;">attach_file</mat-icon>
    <p>ATTACH</p>
  </div>
  <!-- <div style="float: right;margin-top: 8px;">
    <button mat-raised-button color="accent">Submit</button>
  </div> -->
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/components/todo-uploader/todo-uploader.component.html